const locales = {
    // 2-symbol locales
    af: 'Afrikaans',
    am: 'አማርኛ', // Amharic
    ar: 'العربية', // Arabic
    az: 'Azərbaycan dili', // Azerbaijani
    be: 'Беларуская', // Belarusian
    bg: 'Български', // Bulgarian
    bn: 'বাংলা', // Bengali
    bs: 'Bosanski', // Bosnian
    ca: 'Català', // Catalan
    cs: 'Čeština', // Czech
    cy: 'Cymraeg', // Welsh
    da: 'Dansk', // Danish
    de: 'Deutsch', // German
    dv: 'ދިވެހި', // Divehi
    el: 'Ελληνικά', // Greek
    en: 'English',
    es: 'Español', // Spanish
    et: 'Eesti', // Estonian
    eu: 'Euskara', // Basque
    fa: 'فارسی', // Persian
    fi: 'Suomi', // Finnish
    fil: 'Filipino',
    fo: 'Føroyskt', // Faroese
    fr: 'Français', // French
    gl: 'Galego', // Galician
    gu: 'ગુજરાતી', // Gujarati
    he: 'עברית', // Hebrew
    hi: 'हिन्दी', // Hindi
    hr: 'Hrvatski', // Croatian
    hu: 'Magyar', // Hungarian
    hy: 'Հայերեն', // Armenian
    id: 'Bahasa Indonesia', // Indonesian
    is: 'Íslenska', // Icelandic
    it: 'Italiano', // Italian
    ja: '日本語', // Japanese
    ka: 'ქართული', // Georgian
    kk: 'Қазақ', // Kazakh
    km: 'ខ្មែរ', // Khmer
    kn: 'ಕನ್ನಡ', // Kannada
    ko: '한국어', // Korean
    ky: 'Кыргызча', // Kyrgyz
    lo: 'ລາວ', // Lao
    lt: 'Lietuvių', // Lithuanian
    lv: 'Latviešu', // Latvian
    mk: 'Македонски', // Macedonian
    ml: 'മലയാളം', // Malayalam
    mn: 'Монгол', // Mongolian
    mr: 'मराठी', // Marathi
    ms: 'Bahasa Melayu', // Malay
    mt: 'Malti', // Maltese
    nb: 'Norsk Bokmål', // Norwegian Bokmål
    ne: 'नेपाली', // Nepali
    nl: 'Nederlands', // Dutch
    nn: 'Norsk Nynorsk', // Norwegian Nynorsk
    or: 'ଓଡ଼ିଆ', // Oriya
    pa: 'ਪੰਜਾਬੀ', // Punjabi
    pl: 'Polski', // Polish
    pt: 'Português', // Portuguese
    ro: 'Română', // Romanian
    ru: 'Русский', // Russian
    si: 'සිංහල', // Sinhala
    sk: 'Slovenčina', // Slovak
    sl: 'Slovenščina', // Slovenian
    sq: 'Shqip', // Albanian
    sr: 'Српски', // Serbian
    sv: 'Svenska', // Swedish
    sw: 'Kiswahili', // Swahili
    ta: 'தமிழ்', // Tamil
    te: 'తెలుగు', // Telugu
    th: 'ไทย', // Thai
    tr: 'Türkçe', // Turkish
    uk: 'Українська', // Ukrainian
    ur: 'اردو', // Urdu
    uz: 'Oʻzbekcha', // Uzbek
    vi: 'Tiếng Việt', // Vietnamese
    zh: '中文', // Chinese
    zu: 'isiZulu', // Zulu
    // 5-symbol locales
    'af-ZA': 'Afrikaans (Suid-Afrika)',
    'am-ET': 'አማርኛ (ኢትዮጵያ)', // Amharic (Ethiopia)
    'ar-AE': 'العربية (الإمارات)', // Arabic (UAE)
    'ar-SA': 'العربية (السعودية)', // Arabic (Saudi Arabia)
    'az-AZ': 'Azərbaycan dili (Azərbaycan)', // Azerbaijani (Azerbaijan)
    'be-BY': 'Беларуская (Беларусь)', // Belarusian (Belarus)
    'bg-BG': 'Български (България)', // Bulgarian (Bulgaria)
    'bn-BD': 'বাংলা (বাংলাদেশ)', // Bengali (Bangladesh)
    'bn-IN': 'বাংলা (ভারত)', // Bengali (India)
    'bs-BA': 'Bosanski (Bosna i Hercegovina)', // Bosnian (Bosnia and Herzegovina)
    'ca-ES': 'Català (Espanya)', // Catalan (Spain)
    'cs-CZ': 'Čeština (Česko)', // Czech (Czech Republic)
    'cy-GB': 'Cymraeg (Y Deyrnas Unedig)', // Welsh (United Kingdom)
    'da-DK': 'Dansk (Danmark)', // Danish (Denmark)
    'de-AT': 'Deutsch (Österreich)', // German (Austria)
    'de-CH': 'Deutsch (Schweiz)', // German (Switzerland)
    'de-DE': 'Deutsch (Deutschland)', // German (Germany)
    'el-GR': 'Ελληνικά (Ελλάδα)', // Greek (Greece)
    'en-AU': 'English (Australia)',
    'en-GB': 'English (United Kingdom)',
    'en-IN': 'English (India)',
    'en-US': 'English (United States)',
    'es-ES': 'Español (España)', // Spanish (Spain)
    'es-MX': 'Español (México)', // Spanish (Mexico)
    'es-AR': 'Español (Argentina)', // Spanish (Argentina)
    'et-EE': 'Eesti (Eesti)', // Estonian (Estonia)
    'fa-AF': 'درى (افغانستان)', // Dari (Afghanistan)
    'fa-IR': 'فارسى (ايران)', // Farsi (Iran)
    'fi-FI': 'Suomi (Suomi)', // Finnish (Finland)
    'fr-FR': 'Français (France)', // French (France)
    'fr-CA': 'Français (Canada)', // French (Canada)
    'gl-ES': 'Galego (España)', // Galician (Spain)
    'gu-IN': 'ગુજરાતી (ભારત)', // Gujarati (India)
    'he-IL': 'עברית (ישראל)', // Hebrew (Israel)
    'hi-IN': 'हिन्दी (भारत)', // Hindi (India)
    'hr-HR': 'Hrvatski (Hrvatska)', // Croatian (Croatia)
    'hu-HU': 'Magyar (Magyarország)', // Hungarian (Hungary)
    'id-ID': 'Bahasa Indonesia (Indonesia)', // Indonesian (Indonesia)
    'it-IT': 'Italiano (Italia)', // Italian (Italy)
    'ja-JP': '日本語 (日本)', // Japanese (Japan)
    'ka-GE': 'ქართული (საქართველო)', // Georgian (Georgia)
    'kk-KZ': 'Қазақ (Қазақстан)', // Kazakh (Kazakhstan)
    'ko-KR': '한국어 (대한민국)', // Korean (South Korea)
    'ku-IQ': 'سۆرانی (عێراق)', // Sorani (Iraq)
    'lt-LT': 'Lietuvių (Lietuva)', // Lithuanian (Lithuania)
    'lv-LV': 'Latviešu (Latvija)', // Latvian (Latvia)
    'mk-MK': 'Македонски (Северна Македонија)', // Macedonian (North Macedonia)
    'ml-IN': 'മലയാളം (ഇന്ത്യ)', // Malayalam (India)
    'mr-IN': 'मराठी (भारत)', // Marathi (India)
    'ms-MY': 'Bahasa Melayu (Malaysia)', // Malay (Malaysia)
    'my-MM': 'ဗမာစာ (မြန်မာ)', // Burmese (Myanmar)
    'nb-NO': 'Norsk Bokmål (Norge)', // Norwegian Bokmål (Norway)
    'ne-NP': 'नेपाली (नेपाल)', // Nepali (Nepal)
    'nl-NL': 'Nederlands (Nederland)', // Dutch (Netherlands)
    'nn-NO': 'Norsk Nynorsk (Noreg)', // Norwegian Nynorsk (Norway)
    'pl-PL': 'Polski (Polska)', // Polish (Poland)
    'ps-AF': 'پښتو (افغانستان)', // Pashto (Afghanistan)
    'pt-BR': 'Português (Brasil)', // Portuguese (Brazil)
    'pt-PT': 'Português (Portugal)', // Portuguese (Portugal)
    'ro-RO': 'Română (România)', // Romanian (Romania)
    'ru-RU': 'Русский (Россия)', // Russian (Russia)
    'si-LK': 'සිංහල (ශ්‍රී ලංකා)', // Sinhala (Sri Lanka)
    'sk-SK': 'Slovenčina (Slovensko)', // Slovak (Slovakia)
    'sl-SI': 'Slovenščina (Slovenija)', // Slovenian (Slovenia)
    'so-SO': 'Soomaali (Soomaaliya)', // Somali (Somalia)
    'sq-AL': 'Shqip (Shqipëri)', // Albanian (Albania)
    'sr-RS': 'Српски (Србија)', // Serbian (Serbia)
    'sv-SE': 'Svenska (Sverige)', // Swedish (Sweden)
    'sw-KE': 'Kiswahili (Kenya)', // Swahili (Kenya)
    'ta-IN': 'தமிழ் (இந்தியா)', // Tamil (India)
    'te-IN': 'తెలుగు (భారతదేశం)', // Telugu (India)
    'th-TH': 'ไทย (ประเทศไทย)', // Thai (Thailand)
    'ti-ER': 'ትግርኛ (ኤርትራ)', // Tigrinya (Eritrea)
    'tl-PH': 'Tagalog (Pilipinas)', // Tagalog (Philippines)
    'tr-TR': 'Türkçe (Türkiye)', // Turkish (Turkey)
    'ug-CN': 'ئۇيغۇرچە (جۇڭگو)', // Uyghur (China)
    'uk-UA': 'Українська (Україна)', // Ukrainian (Ukraine)
    'ur-IN': 'اردو (ہندوستان)', // Urdu (India)
    'ur-PK': 'اردو (پاکستان)', // Urdu (Pakistan)
    'vi-VN': 'Tiếng Việt (Việt Nam)', // Vietnamese (Vietnam)
    'zh-CN': '中文 (中国)', // Chinese (China)
    'zh-TW': '中文 (台灣)', // Chinese (Taiwan)
    'zu-ZA': 'isiZulu (iNingizimu Afrika)', // Zulu (South Africa)
    // 6-symbol locales
    'ar-arb': 'العربية (عربي)' // Arabic
};

export default locales;
